import { useState, useCallback } from 'react';
import { ToastType } from '../components/common/Toast';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

export const useToast = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const addToast = useCallback((message: string, type: ToastType = 'info', duration = 5000) => {
    console.log('🔔 TOAST: addToast called');
    console.log('🔔 TOAST: message:', message);
    console.log('🔔 TOAST: type:', type);
    console.log('🔔 TOAST: duration:', duration);
    
    const id = `toast-${Date.now()}-${Math.random()}`;
    const newToast: Toast = { id, message, type, duration };
    
    console.log('🔔 TOAST: New toast object created:', newToast);
    
    setToasts((prev) => {
      console.log('🔔 TOAST: setToasts callback - previous toasts:', prev);
      const updated = [...prev, newToast];
      console.log('🔔 TOAST: setToasts callback - updated toasts:', updated);
      return updated;
    });
    
    console.log('🔔 TOAST: addToast returning ID:', id);
    return id;
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showSuccess = useCallback((message: string, duration?: number) => {
    return addToast(message, 'success', duration);
  }, [addToast]);

  const showError = useCallback((message: string, duration?: number) => {
    console.log('🔴 TOAST: showError called with message:', message);
    console.log('🔴 TOAST: current toasts state before adding:', toasts);
    const toastId = addToast(message, 'error', duration || 7000);
    console.log('🔴 TOAST: Error toast added with ID:', toastId);
    return toastId;
  }, [addToast, toasts]);

  const showWarning = useCallback((message: string, duration?: number) => {
    return addToast(message, 'warning', duration || 6000);
  }, [addToast]);

  const showInfo = useCallback((message: string, duration?: number) => {
    return addToast(message, 'info', duration);
  }, [addToast]);

  return {
    toasts,
    addToast,
    removeToast,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};
